import timeOffsetText from "@/utils/timeOffsetText";
import { toLocalDate } from "../utils/Date";

export default function(dateData) {
  const now = new Date();
  const createdDate = toLocalDate(dateData);

  return timeOffsetText(createdDate, now);
}
